export const DIRECT_INDEXING_TOOLTIP_TEXT =
  "Seeks to replicate a chosen benchmark using a smaller subset of stocks.";

export const TAX_LOSS_HARVESTING_TOOLTIP_TEXT =
  "Tax-loss harvesting only impacts taxable accounts.";

export const EQUIVALENT_SECURITIES_TOOLTIP_TEXT =
  "Farther will attempt to prevent trades that involve selling one security to buy another with substantially similar investment exposure. Your model portfolio will still reflect the security initially appearing in the model, but Farther will attempt to retain the legacy position in a given account.";

export const TAX_CHARACTERISTICS_ACROSS_ACCOUNTS_TOOLTIP_TEXT =
  "The tax characteristics of each account within the trading group will be considered when allocating investments across accounts.";

export const SHARED_ACCOUNT_TOOLTIP_TEXT =
  "This account is shared with you. Only the owner can make changes to the model portfolio settings.";

export const IS_LIQUIDATING_TOOLTIP_TEXT =
  "Trading settings is disabled while a liquidation is in progress.";
